module.exports = __webpack_public_path__ + "static/media/chase_serious.5ca24b11.png";